// eslint-disable-next-line no-unused-vars
var navMobile = function () {

    var navMobile_mainNav = document.querySelector('.main-nav');
    if (!navMobile_mainNav || navMobile_mainNav === null || navMobile_mainNav === undefined) {
        return;
    }

    var htmlEl = document.documentElement;
    var navMobile_navIsOpen = false;
    var navMobile_isMobile = !window.matchMedia('(min-width: 980px)').matches;
    var navMobile_mainNavBtns = document.querySelectorAll('.main-nav .main-nav__list-item--top-level > button:not(.main-nav__close-button)');
    var navMobile_currentMainClickedBtn;
    var navMobile_secondLevelBtns = document.querySelectorAll('.main-nav .second-level-links--mobile');
    var navMobile_backBtns = document.querySelectorAll('.main-nav .back');
    var navMobile_closeBtns = document.querySelectorAll('.main-nav .main-nav__close-button--mobile');
    var navMobile_mainNavClassName = '';
    var navMobile_subClassName = '';
    var navMobile_backToTopLevelBtns = document.querySelectorAll('.main-nav .back-to-top-level--mobile');

    var navMobile_insuranceMenu = document.querySelector('[data-product="insurance"] .mobile--nav__mid-menu'); // jshint ignore:line
    var navMobile_insuranceSecondMenu = document.querySelector('[data-product="insurance"] .main-nav__container--mid-level'); // jshint ignore:line
    var navMobile_utilsMenu = document.querySelector('[data-product="utilities"] .mobile--nav__mid-menu'); // jshint ignore:line
    var navMobile_utilsSecondMenu = document.querySelector('[data-product="utilities"] > .main-nav__container--bottom-level'); // jshint ignore:line
    var navMobile_financeMenu = document.querySelector('[data-product="finance"] .mobile--nav__mid-menu'); // jshint ignore:line
    var navMobile_financeSecondMenu = document.querySelector('[data-product="finance"] > .main-nav__container--bottom-level'); // jshint ignore:line
    var navMobile_carCareMenu = document.querySelector('[data-product="car-care-_-selling"] .mobile--nav__mid-menu'); // jshint ignore:line
    var navMobile_carCareSecondMenu = document.querySelector('[data-product="car-care-_-selling"] > .main-nav__container--bottom-level'); // jshint ignore:line
    var noHeightElArr = [];
    var prevScrollpos = window.pageYOffset;

    var tabbableEls = document.querySelectorAll('[data-no-tab-mobile]');
    var buttonText = '';

    // Set all data-buttontext
    document.querySelectorAll('[data-buttontext]').forEach(function (button) {
        var buttonText = button.textContent.trim().replace(/\s+/g, '-').toLowerCase();
        var productEl;
        var subProductEl;
        var subProductText = '';
        var productText = '';
        if (buttonText === 'tools-&-tips') {
            subProductEl = button.closest('[data-sub-product]');
            if (subProductEl) {
                subProductText = subProductEl.dataset.subProduct;
                buttonText = 'tools--' + subProductText;
            } else {
                productEl = button.closest('[data-product]');
                if (productEl) {
                    productText = productEl.dataset.product;
                    buttonText = 'tools--' + productText;
                }
            }
        }
        button.dataset.buttontext = buttonText;
    });

    document.addEventListener('DOMContentLoaded', function () {
        setAllTabIndexes();
    });

    // Set isMobile on browser resize
    window.addEventListener('resize', function () {
        if (window.matchMedia('(min-width: 980px)').matches) {
            var elemClassList;
            // TEST IF IT ALREADY HAS NAV-PRODUCT--BLAH THEN USE THE CLASSLIST TO REPOPULATE AFTER RESIZE OTHERWIZE BLITZ ALL BUT MAIN-NAV CLASS
            if (/nav-product--/.test(navMobile_mainNav.classList)) {
                elemClassList = navMobile_mainNav.classList;
            } else {
                elemClassList = 'main-nav';
                window._navDesktop.closeNav();
            }

            navMobile_isMobile = false;
            navMobile_mainNav.className = elemClassList;
            htmlEl.classList.remove('nav-is-open');
            document.querySelectorAll('.main-nav .active').forEach(function (activeEl) {
                activeEl.classList.remove('active');
            });
            navMobile_navIsOpen = false;
        } else {
            navMobile_isMobile = true;
        }
        setAllTabIndexes();
    });

    window.addEventListener('scroll', function () {
        if (!navMobile_isMobile) { return; }
        if (navMobile_navIsOpen) { return; }
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos || window.pageYOffset < 50) {
            navMobile_mainNav.classList.remove('unpinned');
        } else {
            navMobile_mainNav.classList.add('unpinned');
        }
        prevScrollpos = currentScrollPos;
    });

    document.querySelector('header').addEventListener('keydown', function (event) {
        if (!navMobile_isMobile) { return; }
        if (event.code === 'Tab' && !event.shiftKey) {
            var focusableEl = navMobile_mainNav.querySelectorAll('[data-product="car-care-_-selling"] .main-nav__container--bottom-level [tabindex="0"]'); // jshint ignore:line
            var carCareBtn = document.querySelector('[data-product="car-care-_-selling"] > button'); // jshint ignore:line
            if (document.activeElement === carCareBtn && document.querySelector('[data-product="car-care-_-selling"].active') === null && navMobile_navIsOpen) { // jshint ignore:line
                // focus is on car care main button and car care menu is not open
                event.preventDefault();
                document.querySelector('.active .main-nav__close-button--mobile').focus();
            } else if (document.activeElement === focusableEl[focusableEl.length - 1]) {
                // focus is on last link of any option within care care menu
                event.preventDefault();
                document.querySelector('[data-product="insurance"] > button').focus(); // jshint ignore:line
            }
        } else if (event.code === 'Tab' && event.shiftKey) {
            if (document.activeElement.classList.contains('logo') && navMobile_navIsOpen) {
                // Logo has focus
                event.preventDefault();
                var tabbable = document.querySelectorAll('.main-nav [tabindex=\'0\']:not(.main-nav__close-button)');
                tabbable[tabbable.length - 1].focus();
            }
        }
    });

    document.getElementById('skip-nav-link').addEventListener('click', function () {
        closeMobileNav();
    });

    for (let i = 0; i < navMobile_mainNavBtns.length; i++) {
        navMobile_mainNavBtns[i].addEventListener('click', function (event) { // jshint ignore:line
            if (!navMobile_isMobile) { return; }
            navMobile_navIsOpen = true;
            resetNoHeightClasses();
            onMainNavClick_mobile(event);
            setActiveTabIndexes(event, true);
        });
    }

    for (let i = 0; i < navMobile_secondLevelBtns.length; i++) {
        navMobile_secondLevelBtns[i].addEventListener('click', function (event) { // jshint ignore:line
            if (!navMobile_isMobile) { return; }
            onSecondaryLevelClick(event);
            setActiveTabIndexes(event, false);
        });
    }

    for (let i = 0; i < navMobile_closeBtns.length; i++) {
        navMobile_closeBtns[i].addEventListener('click', function () { // jshint ignore:line
            closeMobileNav();
        });
    }

    for (let i = 0; i < navMobile_backBtns.length; i++) {
        navMobile_backBtns[i].addEventListener('click', function (event) { // jshint ignore:line
            if (!navMobile_isMobile) { return; }
            backOneMenuLayer();
            setAllTabIndexes();
            // set tabIndex = 0 on the menu that is left open
            handleTabbingAfterBackPressed(event);
        });
    }

    for (let i = 0; i < navMobile_backToTopLevelBtns.length; i++) {
        navMobile_backToTopLevelBtns[i].addEventListener('click', function () { // jshint ignore:line
            if (!navMobile_isMobile) { return; }
            document.querySelectorAll('.main-nav .active').forEach(function (activeMenu) {
                if (!activeMenu.classList.contains('main-nav__list-item--top-level')) {
                    activeMenu.classList.remove('active');
                }
            });
            setAllTabIndexes();
            document.querySelectorAll('.main-nav__container--mid-level--ul > li > button').forEach(function (button) {
                button.tabIndex = 0;
            });
            document.querySelector('[data-product="insurance"] .main-nav__close-button--mobile').tabIndex = 0; // jshint ignore:line
            document.querySelector('[data-sub-product="motor-primary"] > button').focus(); // jshint ignore:line
            // add no-height classes back
            setTimeout(function () {
                noHeightElArr.forEach(function (el) {
                    el.classList.add('no-height');
                });
                noHeightElArr = [];
            }, 251);
        });
    }

    function setAllTabIndexes() {
        if (navMobile_isMobile) {
            tabbableEls.forEach(function (element) {
                element.tabIndex = -1;
            });
        } else {
            tabbableEls.forEach(function (element) {
                element.tabIndex = 0;
            });
        }
    }

    function setActiveTabIndexes(event, isFromTopMenu) {
        var closeButton;
        var activeTabbableEls;
        tabbableEls.forEach(function (element) {
            element.tabIndex = -1;
        });
        if (isFromTopMenu) {
            switch (true) {
                case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'insurance':
                    activeTabbableEls = document.querySelectorAll('[data-product="insurance"] .main-nav__container--mid-level [data-no-tab-mobile]:not(.main-nav__container--bottom-level [data-no-tab-mobile]:not(.main-nav__container--mid-level--li-close [data-no-tab-mobile])'); // jshint ignore:line
                    closeButton = document.querySelector('[data-product="insurance"] .mobile--nav__mid-menu button'); // jshint ignore:line
                    break;
                case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'utilities':
                    activeTabbableEls = document.querySelectorAll('[data-product="utilities"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                    closeButton = document.querySelector('[data-product="utilities"] .mobile--nav__mid-menu button'); // jshint ignore:line
                    break;
                case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'finance':
                    activeTabbableEls = document.querySelectorAll('[data-product="finance"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                    closeButton = document.querySelector('[data-product="finance"] .mobile--nav__mid-menu button'); // jshint ignore:line
                    break;
                case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'car-care-_-selling':
                    activeTabbableEls = document.querySelectorAll('[data-product="car-care-_-selling"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                    closeButton = document.querySelector('[data-product="car-care-_-selling"] .mobile--nav__mid-menu button'); // jshint ignore:line
                    break;
            }
        } else {
            if ((event.target.classList.contains('second-level-links--mobile') && event.target.classList.contains('main-nav__options--mid-level')) || event.target.parentElement.dataset.product === 'insurance') {
                activeTabbableEls = event.target.nextElementSibling.querySelectorAll('[data-no-tab-mobile]:not(.main-nav__options--bottom-level > div [data-no-tab-mobile]):not(.main-nav__articles-container [data-no-tab-mobile]');
            } else {
                activeTabbableEls = event.target.nextElementSibling.querySelectorAll('[data-no-tab-mobile]');
            }
            var parentLi = event.target.closest('.main-nav__list-item--top-level');
            closeButton = parentLi.querySelector('.main-nav__close-button--mobile');
        }
        activeTabbableEls.forEach(function (element) {
            element.tabIndex = 0;
        });
        closeButton.tabIndex = 0;
        // Focus the right button
        setTimeout(function () {
            activeTabbableEls[0].focus();
        }, 251);
    }

    function handleTabbingAfterBackPressed(event) {
        var closeButton;
        var activeTabbableEls;
        var elToFocus;
        switch (true) {
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'insurance':
                if (event.target.classList.contains('back-to-insurance')) {
                    activeTabbableEls = document.querySelectorAll('[data-product="insurance"] .main-nav__container--mid-level [data-no-tab-mobile]:not(.main-nav__container--bottom-level [data-no-tab-mobile]:not(.main-nav__container--mid-level--li-close [data-no-tab-mobile])'); // jshint ignore:line
                    var product = event.target.innerText.toLowerCase();
                    if (product === 'motor' || product === 'business') {
                        product = product + '-primary';
                    }
                    elToFocus = document.querySelector('[data-sub-product="' + product + '"] > button'); // jshint ignore:line
                } else {
                    elToFocus = document.querySelector('[data-product="insurance"] .main-nav__container--mid-level [data-buttontext="' + buttonText + '"]'); // jshint ignore:line
                    activeTabbableEls = elToFocus.closest('.main-nav__container--bottom-level--ul').querySelectorAll('[data-no-tab-mobile]:not(.main-nav__options--bottom-level > div [data-no-tab-mobile]):not(.main-nav__articles-container [data-no-tab-mobile]');
                }
                closeButton = document.querySelectorAll('[data-product="insurance"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                break;
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'utilities':
                activeTabbableEls = document.querySelectorAll('[data-product="utilities"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                closeButton = document.querySelector('.active .main-nav__close-button--mobile');
                elToFocus = document.querySelector('[data-product="utilities"] [data-buttontext="' + buttonText + '"]'); // jshint ignore:line
                break;
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'finance':
                activeTabbableEls = document.querySelectorAll('[data-product="finance"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                closeButton = document.querySelector('.active .main-nav__close-button--mobile');
                elToFocus = document.querySelector('[data-product="finance"] [data-buttontext="' + buttonText + '"]'); // jshint ignore:line
                break;
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'car-care-_-selling':
                activeTabbableEls = document.querySelectorAll('[data-product="car-care-_-selling"] .main-nav__container--bottom-level .second-level-links--mobile'); // jshint ignore:line
                closeButton = document.querySelector('.active .main-nav__close-button--mobile');
                elToFocus = elToFocus = document.querySelector('[data-product="car-care-_-selling"] [data-buttontext="' + buttonText + '"]'); // jshint ignore:line
                break;
        }
        closeButton.tabIndex = 0;
        activeTabbableEls.forEach(function (element) {
            element.tabIndex = 0;
        });
        elToFocus.focus();
    }

    function onMainNavClick_mobile(event) {
        if (!navMobile_isMobile) { return; }
        navMobile_currentMainClickedBtn = event.target;
        htmlEl.classList.add('nav-is-open');
        navMobile_openSecondaryMenu();
    }

    function onSecondaryLevelClick(event) {
        if (!navMobile_isMobile) { return; }
        var button = event.target;
        buttonText = button.dataset.buttontext;
        if (navMobile_subClassName !== '') {
            navMobile_mainNav.classList.remove(navMobile_subClassName);
        }
        navMobile_subClassName = navMobile_mainNavClassName + '--' + buttonText;
        removeNoHeightClasses(event);
        navMobile_mainNav.classList.add(navMobile_subClassName);

        var activeDiv = button.nextElementSibling;
        if (activeDiv) {
            activeDiv.classList.add('active');
        }

        scrollTopAllMenus();
    }

    function scrollTopAllMenus() {
        if (!navMobile_isMobile) { return; }
        var midMenu = document.querySelector('.main-nav__container--mid-level--ul');
        var bottomMenus = document.querySelectorAll('.main-nav__container--bottom-level--ul');
        var toolsMenus = document.querySelectorAll('.main-nav__articles-container');
        midMenu.scrollTop = 0;
        bottomMenus.forEach(function (el) {
            el.scrollTop = 0;
        });
        toolsMenus.forEach(function (el) {
            el.scrollTop = 0;
        });
    }

    function navMobile_openSecondaryMenu() {
        if (!navMobile_isMobile) { return; }
        document.querySelectorAll('.main-nav .active').forEach(function (activeEl) {
            activeEl.classList.remove('active');
        });
        switch (true) {
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'insurance':
                navMobile_mainNavClassName = 'nav--is-open-mobile--insurance';
                navMobile_insuranceMenu.classList.remove('no-height');
                navMobile_insuranceSecondMenu.classList.remove('no-height');
                document.querySelector('[data-product="insurance"]').classList.add('active'); // jshint ignore:line
                break;
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'utilities':
                navMobile_mainNavClassName = 'nav--is-open-mobile--utilities';
                navMobile_utilsMenu.classList.remove('no-height');
                navMobile_utilsSecondMenu.classList.remove('no-height');
                document.querySelector('[data-product="utilities"]').classList.add('active'); // jshint ignore:line
                break;
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'finance':
                navMobile_mainNavClassName = 'nav--is-open-mobile--finance';
                navMobile_financeMenu.classList.remove('no-height');
                navMobile_financeSecondMenu.classList.remove('no-height');
                document.querySelector('[data-product="finance"]').classList.add('active'); // jshint ignore:line
                break;
            case navMobile_currentMainClickedBtn.parentElement.dataset.product === 'car-care-_-selling':
                navMobile_mainNavClassName = 'nav--is-open-mobile--car-care';
                navMobile_carCareMenu.classList.remove('no-height');
                navMobile_carCareSecondMenu.classList.remove('no-height');
                document.querySelector('[data-product="car-care-_-selling"]').classList.add('active'); // jshint ignore:line
                break;
            default:
                return;
        }
        navMobile_mainNav.className = 'main-nav nav--is-open-mobile ' + navMobile_mainNavClassName;
    }

    function backOneMenuLayer() {
        if (!navMobile_isMobile) { return; }
        if (noHeightElArr.length > 0) {
            var menuToClose = noHeightElArr[noHeightElArr.length - 1];
            menuToClose.classList.remove('active');
            setTimeout(function () {
                menuToClose.classList.add('no-height');
            }, 251);
            noHeightElArr.pop();
        }
    }

    // Observer to add faders to mobile menu
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            addOrRemoveFader(entry);
        });
    }, { threshold: 1 });

    [document.querySelector('[data-product="insurance"] > button'), document.querySelector('[data-product="car-care-_-selling"] > button')].forEach(function (btnEl) { // jshint ignore:line
        observer.observe(btnEl);
    });

    function addOrRemoveFader(element) {
        if (!navMobile_isMobile) { return; }
        var elId = element.target;
        elId.closest('[data-product]').dataset.product === 'insurance'; // jshint ignore:line
        var isIntersecting = element.isIntersecting;
        var navUl = document.querySelector('.main-nav__container');
        if (elId.closest('[data-product]').dataset.product === 'insurance') { // jshint ignore:line
            if (isIntersecting) {
                navUl.classList.remove('first-option-off-screen');
            } else {
                navUl.classList.add('first-option-off-screen');
            }
        } else {
            if (isIntersecting) {
                navUl.classList.remove('last-option-off-screen');
            } else {
                navUl.classList.add('last-option-off-screen');
            }
        }
    }

    function removeNoHeightClasses(event) {
        if (!navMobile_isMobile) { return; }
        var button = event.target;
        var noHeightEl = button.nextElementSibling;
        noHeightEl.classList.remove('no-height');
        if (!noHeightElArr.includes(noHeightEl)) {
            noHeightElArr.push(noHeightEl);
        }
    }

    function closeMobileNav() {
        if (!navMobile_isMobile) { return; }
        navMobile_navIsOpen = false;
        document.querySelectorAll('.main-nav .active').forEach(function (activeEl) {
            activeEl.classList.remove('active');
        });
        setTimeout(function () {
            htmlEl.classList.remove('nav-is-open');
            resetNoHeightClasses();
            setAllTabIndexes();
        }, 251);
    }

    function resetNoHeightClasses() {
        if (!navMobile_isMobile) { return; }
        var menus = [
            navMobile_insuranceMenu,
            navMobile_insuranceSecondMenu,
            navMobile_utilsMenu,
            navMobile_utilsSecondMenu,
            navMobile_financeMenu,
            navMobile_financeSecondMenu,
            navMobile_carCareMenu,
            navMobile_carCareSecondMenu
        ];
        menus.forEach(function (menu) {
            menu.classList.add('no-height');
        });
        noHeightElArr.forEach(function (el) {
            el.classList.add('no-height');
        });
        noHeightElArr = [];
    }
}();